import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AlertProvider } from './contexts/AlertContext';
import AlertToast from './components/common/AlertToast';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Páginas
import LoginPage from './pages/Login';
import DashboardPage from './pages/Dashboard';
import ProjectsPage from './pages/Projects';
import NewProject from './pages/NewProject';
import EditProject from './pages/EditProject';
import ArticlesPage from './pages/Articles';
import NewArticle from './pages/NewArticle';
import EditArticle from './pages/EditArticle';
import InquiriesPage from './pages/Inquiries';
import QuotesPage from './pages/Quotes';
import TeamPage from './pages/Team';
import NewTeam from './pages/NewTeam';
import EditTeam from './pages/EditTeam';
import Users from './pages/Users';

const App: React.FC = () => {
  return (
    <AlertProvider>
      <Router>
        <AlertToast />
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* --- DASHBOARD (Acceso para todos los logueados) --- */}
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          
          {/* --- PROYECTOS --- */}
          <Route path="/projects" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} />
          
          {/* Crear/Editar: Solo Admin y Editor */}
          <Route path="/projects/new" element={
              <ProtectedRoute allowedRoles={['administrador', 'editor']}>
                  <NewProject />
              </ProtectedRoute>
          } />
          <Route path="/projects/edit/:id" element={
              <ProtectedRoute allowedRoles={['administrador', 'editor']}>
                  <EditProject />
              </ProtectedRoute>
          } />

          {/* --- ARTÍCULOS --- */}
          <Route path="/articles" element={<ProtectedRoute><ArticlesPage /></ProtectedRoute>} />
          
          <Route path="/articles/new" element={
              <ProtectedRoute allowedRoles={['administrador', 'editor']}>
                  <NewArticle />
              </ProtectedRoute>
          } />
          <Route path="/articles/edit/:id" element={
              <ProtectedRoute allowedRoles={['administrador', 'editor']}>
                  <EditArticle />
              </ProtectedRoute>
          } />

          {/* --- MENSAJES Y COTIZACIONES (Todos pueden ver, lógica interna maneja acciones) --- */}
          <Route path="/messages" element={<ProtectedRoute><InquiriesPage /></ProtectedRoute>} />
          <Route path="/quotes" element={<ProtectedRoute><QuotesPage /></ProtectedRoute>} />

          {/* --- EQUIPO --- */}
          <Route path="/team" element={<ProtectedRoute><TeamPage /></ProtectedRoute>} />
          
          <Route path="/team/new" element={
              <ProtectedRoute allowedRoles={['administrador']}>
                  <NewTeam />
              </ProtectedRoute>
          } />
          <Route path="/team/edit/:id" element={
              <ProtectedRoute allowedRoles={['administrador']}>
                  <EditTeam />
              </ProtectedRoute>
          } />

          {/* --- USUARIOS (Solo Administrador) --- */}
          <Route path="/users" element={
                  <Users />
          } />
          
          <Route path="*" element={<h1>404 | Página No Encontrada</h1>} />
        </Routes>
      </Router>
    </AlertProvider>
  );
};

export default App;